import { render, staticRenderFns } from "./addQuestionVideo.vue?vue&type=template&id=3a84b9f6&scoped=true&"
import script from "./addQuestionVideo.vue?vue&type=script&lang=js&"
export * from "./addQuestionVideo.vue?vue&type=script&lang=js&"
import style0 from "./addQuestionVideo.vue?vue&type=style&index=0&id=3a84b9f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a84b9f6",
  null
  
)

export default component.exports